module.exports = __webpack_public_path__ + "assets/img/bg_operaterule_round.1e278a03.png";